import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';

const init = () => {
  const jQueryslider = jQuery('.slick');
  const jQueryprogressBar = jQuery('.progress');
  const jQueryprogressBarLabel = jQuery('.progress-label');

  const updateBar = (current, count) => {
    const calc = (current / count) * 100;

    jQueryprogressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc);

    jQueryprogressBarLabel.text(current + '/' + count);
  };

  jQueryslider.on(
    'beforeChange',
    function (event, slick, currentSlide, nextSlide) {
      updateBar(nextSlide + 1, slick.slideCount);
    },
  );

  jQueryslider.on('init', function (event, slick) {
    updateBar(1, slick.slideCount);
  });

  jQueryslider.slick();
};

export default init;
